import { Client } from 'src/api/Client';

export interface SpaceKbAskRequest {
  question: string;
  // Client-generated UUID; reuse it across questions so the agent keeps
  // the conversation context. The backend namespaces it per admin user.
  session_id: string;
}

export interface SpaceKbAskResponse {
  answer: string;
}

class SpaceKnowledgeClient extends Client {
  private readonly Route = {
    ASK: `${this.http.baseUrl}/admin/space-kb/ask`,
  };

  /**
   * Ask the Space Knowledge Base agent a natural-language question about
   * Space content (requests, brands). Blocking call — the agent answer can
   * take a while, so callers should show a pending state.
   */
  ask(data: SpaceKbAskRequest): Promise<SpaceKbAskResponse> {
    return this.http.post<SpaceKbAskResponse>(
      this.Route.ASK,
      data,
    ) as unknown as Promise<SpaceKbAskResponse>;
  }
}

export { SpaceKnowledgeClient };
